module.exports = __webpack_public_path__ + "img/swiper_6.c702da83.jpg";